import { UIA_MODAL_WORKFLOW } from '@uia/uia-workflow/uia-workflow-constants';
import { IUIAModalWorkflow } from '@uia/uia-workflow/uia-workflow-model';

const initialState: IUIAModalWorkflow = {
  currentIndex: null,
  currentWorkflow: null,
  previousWorkflow: null,
};

export default function WorkflowReducer(state: IUIAModalWorkflow = initialState, action): IUIAModalWorkflow {
  switch (action.type) {
    case UIA_MODAL_WORKFLOW.SET_CURRENT_WORKFLOW: {
      return {
        ...state,
        currentWorkflow: action.payload.currentWorkflow,
        previousWorkflow: action.payload.previousWorklfow,
      };
    }

    case UIA_MODAL_WORKFLOW.SET_CURRENT_INDEX: {
      return {
        ...state,
        currentIndex: action.payload,
      };
    }

    default:
      return state;
  }
}
